/* Loupe – article page: reading-progress bar, active "In this story" link, copy-link button.
   Everything else on the article page (contents, takeaways, FAQ) is rendered by Liquid and works without this file. */
if (!customElements.get('article-reader')) {
  customElements.define('article-reader', class extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('[data-article-body]');
      this.bar = this.querySelector('.art-prog i');
      this.links = [...this.querySelectorAll('[data-toc-link]')];
      const ids = [...new Set(this.links.map((a) => decodeURIComponent(a.hash.slice(1))))];
      this.heads = ids.map((id) => document.getElementById(id)).filter(Boolean);
      this.active = null;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.ticking = false; this.update(); });
      };
      if (this.body && (this.bar || this.heads.length)) {
        addEventListener('scroll', this.onScroll, { passive: true });
        addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }
      // close the mobile contents after a jump
      this.querySelectorAll('.art-mtoc a').forEach((a) => a.addEventListener('click', () => { a.closest('details').open = false; }));
      this.querySelectorAll('[data-copy-link]').forEach((btn) => btn.addEventListener('click', () => this.copy(btn)));
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
    }

    update() {
      // read first, write after
      const r = this.body.getBoundingClientRect();
      const offset = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 68) + 40;
      let on = null;
      for (const h of this.heads) { if (h.getBoundingClientRect().top <= offset) on = h.id; else break; }
      if (this.bar) {
        const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - innerHeight)));
        this.bar.style.transform = `scaleX(${p})`;
      }
      if (on !== this.active) {
        this.active = on;
        this.links.forEach((a) => {
          const hit = decodeURIComponent(a.hash.slice(1)) === on;
          a.classList.toggle('is-on', hit);
          if (hit) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
        });
      }
    }

    async copy(btn) {
      const out = btn.closest('.art-share')?.querySelector('.art-copied');
      const url = btn.dataset.copyLink || location.href;
      try {
        await navigator.clipboard.writeText(url);
        if (out) out.textContent = this.dataset.copied || 'Link copied';
      } catch (e) {
        if (out) out.textContent = url;
      }
      clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => { if (out) out.textContent = ''; }, 2500);
    }
  });
}
